const STORAGE_PREFIX = "deliveryapp.favorites.v1";

export function favoritesStorageKey(marketKey: string, storefrontSlug: string): string {
  return `${STORAGE_PREFIX}.${marketKey}.${storefrontSlug}`;
}

export function parseFavorites(raw: string | null): Set<string> {
  if (raw === null) return new Set();
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return new Set();
    return new Set(
      parsed.filter((value): value is string => typeof value === "string" && value.trim().length > 0).slice(0, 500),
    );
  } catch {
    return new Set();
  }
}

export function readFavorites(key: string): Set<string> {
  try {
    return parseFavorites(window.localStorage.getItem(key));
  } catch {
    return new Set();
  }
}

export function writeFavorites(key: string, favorites: ReadonlySet<string>): void {
  try {
    window.localStorage.setItem(key, JSON.stringify([...favorites].slice(0, 500)));
  } catch {
    // Favoritele sunt confort local; lipsa stocării nu trebuie să blocheze meniul.
  }
}
